import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoMdArrowBack } from 'react-icons/io';
import { Modal, Button, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { createTemplate, editTemplate, getFooterListingPaginate, getHeaderListingPaginate, getTemplateDetails, submitImageTemplate } from '../../api/context/template';
import AsyncSelect from 'react-select/async';
import upload from '../../assets/images/upload-icon.svg';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { getHeaderTemplateDetails } from '../../api/context/header';
import { getFooterTemplateDetails } from '../../api/context/footer';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_MCE_API_KEY } from '../../utils/config.js'


const customStyles = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
        marginBottom: '12px'
    }),
};

const TemplateEmailCreate = () => {

    const navigate = useNavigate();
    const { id } = useParams();


    const fileInputRefs = useRef([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [headerList, setHeaderList] = useState([]);
    const [footerList, setFooterList] = useState([]);
    // const [selectedHeaders, setSelectedHeaders] = useState(null);
    // const [selectedFooters, setSelectedFooters] = useState(null);
    const [imageForms, setImageForms] = useState([]);
    const [imageSrcList, setImageSrcList] = useState([]);
    const [oldImages, setOldImages] = useState([]);
    // Crop related state
    const [showImageUploadModal, setImageUploadModal] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [cropperInstance, setCropperInstance] = useState(null);
    const [currentCropIndex, setCurrentCropIndex] = useState(null);
    const [previewdataheader, setPreviewHeaderData] = useState([]);
    const [previewdatafooter, setPreviewFooterData] = useState([]);
    const [editorForms, setEditorForms] = useState([{ id: 0 }]);
    const [editorDataList, setEditorDataList] = useState([]);

    // console.log(previewdataheader, 'previewdataheader');

    const [isFormFilled, setIsFormFilled] = useState(false);

    useEffect(() => {
        // Ensure there's at least one editor form on initial load
        if (editorForms.length === 0) {
            addEditorForm();
        }
    }, []);



    // Function to check if the form is filled
    const checkFormFilled = () => {
        // Check if all required fields have values
        const filled =
            formik.values.subject !== '' &&
            formik.values.content !== '' &&
            formik.values.template_header !== '' &&
            formik.values.template_footer !== '';

        setIsFormFilled(filled);
    };


    const formik = useFormik({
        initialValues: {
            template_type: '',
            subject: '',
            content: '',
            is_active: true,
            template_header: '',
            template_footer: '',
            force_send_email: false
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);

            try {
                if (id) {
                    editTemplate(id, values)((response) => {
                        if (response && response?.data?.status_code === 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("Template Updated Successfully");
                            navigate("/template-email");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.error_message);
                        }
                    });
                } else {

                    createTemplate(values)((response) => {
                        if (response && response?.data?.status_code === 201) {
                            setLoading(false);
                            resetForm();
                            toast.success("Template Created Successfully");
                            navigate("/template-email");
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.error_message);
                        }
                    });
                }
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        },
    });


    const handleTitleChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };

    const editorRef = useRef(null);

    const insertPlaceholder = (placeholder) => {

        if (editorRef.current) {
            const editor = editorRef.current;
            console.log(editor, 'editor');
            // // Insert the placeholder text with markers
            const placeholderText = `${placeholder}`;


            editor.insertContent(placeholderText);

            // Move the cursor inside the placeholder
            const rng = editor.selection.getRng(); // Get current range

            const startOffset = rng.startOffset - placeholderText.length + 1; // Calculate new start offset

            // Update the range to place the cursor inside the placeholder
            rng.setStart(rng.startContainer, startOffset);
            rng.setEnd(rng.startContainer, startOffset);

            editor.selection.setRng(rng); // Apply the updated range
            editor.focus(); // Ensure the editor is focused
        }
    };

    const insertSubjectPlaceholder = (placeholder) => {
        const cursorPosition = formik.values.subject.length;
        const updatedSubject = formik.values.subject + placeholder;
        formik.setFieldValue('subject', updatedSubject);

        // Move the cursor inside the placeholder
        setTimeout(() => {
            const input = document.querySelector('input[name="subject"]');
            if (input) {
                const startOffset = cursorPosition + 1;
                const endOffset = cursorPosition + placeholder.length - 1;
                input.setSelectionRange(startOffset, endOffset);
                input.focus();
            }
        }, 0);
    };



    const convertPlaceholdersToHtml = (content) => {
        if (!content) return "";

        // Regex to find placeholders in the format ^Button^ and {Link}
        const buttonRegex = /\^([^^]+)\^/g; // Matches ^Button^ and extracts "Button"
        const linkRegex = /\{([^{}]+)\}/g; // Matches {Link} and extracts "Link"

        // Replace ^Button^ with <button>Button</button>
        const convertedContent = content
            .replace(buttonRegex, (match, p1) => `<button class="custom-button">${p1}</button>`)
            .replace(linkRegex, (match, p1) => `<a href="#" class="custom-link">${p1}</a>`);

        return convertedContent;
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    let typingTimer;
    const loadOptionsHeader = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2) {
                    getHeaderListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        if (response?.status_code === 200) {
                            const apiData = response?.data || [];
                            const dynamicOption = { label: 'Dynamic', value: 'DYNAMIC' };
                            const options = [dynamicOption, ...apiData];
                            resolve(options);
                            setHeaderList(options);
                        } else {
                            resolve([]);
                        }
                    });
                } else {
                }
            }, 300);
        });
    };

    const loadOptionsFooter = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2) {
                    getFooterListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        if (response?.statusCode === 200) {
                            const apiData = response?.data || [];
                            const dynamicOption = { label: 'Dynamic', value: 'DYNAMIC' };
                            const options = [dynamicOption, ...apiData];
                            resolve(options);
                            setFooterList(options)
                        } else {
                            resolve([]);
                        }
                    })
                }
                else {
                }
            }, 300);
        });
    };




    const handleCropSave = () => {
        if (cropperInstance) {
            cropperInstance.getCroppedCanvas().toBlob((blob) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const croppedImageUrl = reader.result; // Base64 data URL

                    // Update image_base64 in formik's contents array
                    const updatedContents = [...formik.values.content];
                    updatedContents[currentCropIndex].image_base64 = croppedImageUrl;
                    formik.setFieldValue('content', updatedContents);

                    // Cleanup Cropper and close modal
                    cropperInstance.destroy();
                    setImageUploadModal(false);
                };
                reader.readAsDataURL(blob);
            }, 'image/jpeg');
        }
    };





    const initializeCropper = () => {
        if (currentImage) {
            const imageElement = document.getElementById('current-image');
            const cropper = new Cropper(imageElement, {
                aspectRatio: NaN, // Allow free aspect ratio
                autoCropArea: 1, // Crop the entire image
                viewMode: 1, // Set cropping mode to "move"
            });
            setCropperInstance(cropper);
        }
    };



    const onHeaderChange = (selectedOption) => {
        // console.log(selectedOption, 'selectedOption');
        // setSelectedHeaders(selectedOption?.label);
        formik.setValues({
            ...formik.values,
            template_header: selectedOption ? selectedOption.value : '',
            selectedHeader: selectedOption,
        });
    };

    const onFooterChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            template_footer: selectedOption ? selectedOption.value : '',
            selectedFooter: selectedOption,
        });
    };

    const addImageForm = () => {
        setImageUploadModal(true)
    }

    const handleImageUpload = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const updatedImageSrcList = [...imageSrcList];
                updatedImageSrcList[index] = reader.result; // Update with base64 data
                setImageSrcList(updatedImageSrcList);
                setCurrentCropIndex(index);
                setCurrentImage(reader.result); // Store the uploaded image for cropping
                setImageUploadModal(true);
                submitImage(file.name, reader.result); // Submit image to the API
            };
            reader.readAsDataURL(file);
        }
    };

    const submitImage = async (fileName, base64Data) => {
        const data = {
            file_name: fileName,
            image_base64: base64Data,
        };

        submitImageTemplate(data)((response) => {
            if (response && response?.data?.status_code === 201) {
                const imageUrl = response?.data?.data?.image_url;
                copyImageUrlToClipboard(imageUrl);
            } else {
            }
        });
    };

    const copyImageUrlToClipboard = (url) => {
        navigator.clipboard.writeText(url).then(() => {
            toast.success('Image URL copied to clipboard');
            handleModalClose()
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };




    const removeImageForm = (index, imageRemoved = false) => {
        // Remove from imageForms state
        const updatedImageForms = imageForms.filter((form, idx) => idx !== index);
        setImageForms(updatedImageForms);

        // Remove from imageSrcList state
        const updatedImageSrcList = [...imageSrcList];
        updatedImageSrcList.splice(index, 1);
        setImageSrcList(updatedImageSrcList);

        // Optionally update formik.values.contents if needed
        const updatedContents = [...formik.values.content];
        if (index < updatedContents.length) {
            updatedContents[index].image_remove = true;
            formik.setFieldValue('content', updatedContents);
        }

        // Check if an image was actually removed
        if (imageRemoved) {
            // Perform any additional actions if needed
        }
    };

    const addEditorForm = () => {
        const nextOrder = editorForms.length;

        // Update editorForms with new form ID
        setEditorForms([...editorForms, { id: nextOrder }]);

        // Update editorDataList with new form data (if necessary)
        setEditorDataList(prevList => [
            ...prevList,
            {
                order: nextOrder,
                content: '', // Initialize with empty content
                image_remove: false,
                image_base64: '',
            }
        ]);

        // Update formik values to include new editor content
        formik.setFieldValue('content', [
            ...formik.values.content,
            {
                order: nextOrder,
                content: '',
                image_remove: false,
                image_base64: '',
            },
        ]);
    };


    const handleEditorChange = (content, editor) => {
        // console.log('Content was updated:', content);
        formik.setFieldValue('content', content);
    };


    const handleModalClose = () => {
        setImageUploadModal(false);
        setCurrentImage(null);
    };



    const getTemplate = async () => {
        setLoading(true);
        getTemplateDetails(id)(async (response) => {
            if (response?.data?.status_code === 200) {
                const template = response?.data?.data;

                formik.setValues((prevState) => ({
                    ...prevState,
                    id: id,
                    selectedHeader: {
                        ...template.template_header,
                    },
                    template_header: template.template_header?.value || '',
                    template_type: template.template_type || '',
                    subject: template?.subject || '',
                    content: template?.content || '', // Use the transformed content array
                    selectedFooter: {
                        ...template.template_footer,
                    },
                    template_footer: template.template_footer?.value || '',
                    force_send_email: template?.force_send_email
                }));

                setLoading(false);
            } else {
                setLoading(false);
            }
        });
    };



    const getHeaderTemplate = async () => {
        if (formik.values.template_header !== 'DYNAMIC') {
            getHeaderTemplateDetails(formik.values.template_header)(async (response) => {
                if (response?.data?.status_code === 200) {
                    const header = response?.data?.data
                    // console.log(header, 'header');
                    setPreviewHeaderData(header)
                    setLoading(false)
                } else {
                    setLoading(false)
                }
            })
        } else {
            setLoading(false)
        }
    }

    const getFooterTemplate = async () => {
        if (formik.values.template_footer !== 'DYNAMIC') {
            getFooterTemplateDetails(formik.values.template_footer)(async (response) => {
                if (response?.data?.status_code === 200) {
                    const footer = response?.data?.data
                    setPreviewFooterData(footer)
                    setLoading(false)
                } else {
                    setLoading(false)
                }
            })
        } else {
            setLoading(false)
        }
    }


    useEffect(() => {

        getHeaderListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.status_code === 200) {
                const apiData = response?.data || [];
                const dynamicOption = { label: 'Dynamic', value: 'DYNAMIC' };
                const options = [dynamicOption, ...apiData];
                setHeaderList(options);
            }
        });

        getFooterListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.status_code === 200) {
                const apiData = response?.data || [];
                const dynamicOption = { label: 'Dynamic', value: 'DYNAMIC' };
                const options = [dynamicOption, ...apiData];
                setFooterList(options)
            } else {
            }
        })


    }, []);

    useEffect(() => {
        if (id) {
            setLoading(true)
            getTemplate()

        }
    }, [id])

    useEffect(() => {
        if (formik.values.template_header) {
            setLoading(true)
            getHeaderTemplate()

        }
    }, [formik.values.template_header])

    useEffect(() => {
        if (formik.values.template_footer) {
            setLoading(true)
            getFooterTemplate()

        }
    }, [formik.values.template_footer])

    useEffect(() => {
        checkFormFilled();
    }, [formik.values]);

    console.log(formik);

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center">
                        <Link to='/template-email' className='back_btn_wrap'>
                            <IoMdArrowBack className='icon' />
                        </Link>
                        <h4 className="mb-sm-0">Add Template</h4>
                    </div>
                </div>
            </div>
            <div className='header_email_wrapper'>
                <Form onSubmit={formik.handleSubmit}>
                    <Form.Group className="mb-3" controlId="formBasic">
                        <Form.Label>Template Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter template name"
                            name='template_type'
                            value={formik.values.template_type}
                            onChange={handleTitleChange}
                            isValid={formik.touched.template_type && !formik.errors.template_type}
                            isInvalid={formik.touched.template_type && !!formik.errors.template_type}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.template_type}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <div className='btn_wrapper_email'>
                        <button
                            type="button"
                            className="remove_email_form m-0"
                            onClick={() => insertSubjectPlaceholder('[]')}
                        >
                            Parameter
                        </button>
                    </div>

                    <Form.Group className="mb-3" controlId="formBasic">
                        <Form.Label>Mail Subject</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter mail subject"
                            name="subject"
                            value={formik.values.subject}
                            onChange={handleTitleChange}
                            isValid={formik.touched.subject && !formik.errors.subject}
                            isInvalid={formik.touched.subject && !!formik.errors.subject}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formik.errors.subject}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Label>Select Header</Form.Label>
                    <AsyncSelect
                        loadOptions={loadOptionsHeader}
                        defaultOptions={headerList}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Search Headers'}
                        onChange={onHeaderChange}
                        value={formik.values.selectedHeader}
                        styles={{
                            menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                            }),
                        }}

                    />
                    <div>
                        <div className='btn_wrapper_email'>
                            <Button className='add_email_form' onClick={addImageForm}>Upload Image</Button>

                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('[]')}
                            >
                                Parameter
                            </button>
                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('^^')}
                            >
                                Button
                            </button>
                            <button
                                type="button"
                                className='remove_email_form'
                                onClick={() => insertPlaceholder('{}')}
                            >
                                Link
                            </button>
                        </div>
                        <Editor
                            apiKey={TINY_MCE_API_KEY}
                            onInit={(evt, editor) => (editorRef.current = editor)}
                            init={{
                                // Free plugins and configuration
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | ' +
                                    'bold italic backcolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                height: 500,
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
                                // Optionally retain the AI request configuration if required
                                ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                            }}
                            value={formik?.values?.content}
                            onEditorChange={handleEditorChange}
                        />
                        {/* <Editor
                                    apiKey={TINY_MCE_API_KEY}
                                    onInit={(evt, editor) => (editorRef.current = editor)}
                                    value={formik?.values?.content}
                                    init={{
                                        // Free plugins and configuration
                                        plugins: [
                                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                        ],
                                        toolbar: 'undo redo | blocks | ' +
                                            'bold italic backcolor | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'removeformat | help',
                                        height: 500,
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
                                        // Optionally retain the AI request configuration if required
                                        ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                                    }}
                                    onEditorChange={handleEditorChange}
                                /> */}
                    </div>



                    {/* Image Forms */}
                    {imageForms.map((form, index) => (
                        <div key={form.id}>
                            <div className='fileUploader'>
                                <div className="fileContainer">
                                    <img src={imageSrcList[index] || upload} alt='Upload Icon' className='uploadIcon' />
                                    <p>Max file size: 5mb, accepted: jpg|gif|png</p>
                                    <input
                                        type="file"
                                        accept=".jpg, .png"
                                        onChange={(event) => handleImageUpload(event, index)}
                                        style={{ display: 'none' }}
                                        ref={el => fileInputRefs.current[index] = el}
                                    />
                                    {id && oldImages?.length > 0 &&
                                        <div className='pos-rel'>
                                            {oldImages?.map((image, imgIndex) => (
                                                <img
                                                    key={imgIndex}
                                                    src={image}
                                                    alt={`Existing`}
                                                    className="img-fluid uploaded-image mb-4"
                                                />
                                            ))}
                                        </div>
                                    }
                                    <button
                                        type="button"
                                        className="chooseFileButton"
                                        onClick={() => fileInputRefs.current[index].click()}
                                    >
                                        Choose image
                                    </button>
                                </div>
                            </div>
                            <div className='btn_wrapper_email'>
                                <Button className='remove_email_form' onClick={() => removeImageForm(index, true)}>Remove Image</Button>
                            </div>
                        </div>
                    ))}

                    <Form.Label>Select Footer</Form.Label>
                    <AsyncSelect
                        loadOptions={loadOptionsFooter}
                        defaultOptions={footerList}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Search Footers'}
                        onChange={onFooterChange}
                        value={formik.values.selectedFooter}
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: "8px 8px 8px 8px",
                            colors: {
                                ...theme.colors,
                                primary: '#779be1',
                            },
                        })}
                        styles={customStyles}
                    />

                    <Form.Group className="mb-3" controlId="formBasic">
                        <Form.Label>Send via Queue</Form.Label>
                        <Form.Check
                            type="switch"
                            id="custom-switch"
                            className='send_via_queue'
                            checked={formik.values.force_send_email}
                            onChange={(e) => formik.setFieldValue("force_send_email", e.target.checked)}
                        />
                    </Form.Group>

                    <div className='btn_wrapper_bottom mt-4'>
                        {isFormFilled && (
                            <Button className='add_email_form' onClick={handleShowModal}>
                                Preview
                            </Button>
                        )}
                        <Button className='cancel_btn_form' onClick={() => navigate(-1)}>Cancel</Button>
                        <Button className='save_form_data' type='submit' disabled={loading}>
                            {loading ? "Loading" : id ? "Update" : "Create"}
                        </Button>
                    </div>
                </Form>
            </div>

            {/* Crop Modal */}




            {/* Crop Modal */}
            <Modal className='crop_image_wrapper' show={showImageUploadModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='fileUploader'>
                        <div className="fileContainer">
                            {currentImage ? (
                                <img src={currentImage} alt='Uploaded Image' className='uploadIcon img-fluid' />
                            ) : (
                                <img src={upload} alt='Upload Icon' className='uploadIcon' />
                            )}
                            <p>Max file size: 5mb, accepted: jpg|gif|png</p>
                            <input
                                type="file"
                                accept=".jpg, .png"
                                onChange={(event) => handleImageUpload(event, currentCropIndex)}
                                style={{ display: 'none' }}
                                ref={el => fileInputRefs.current = el}
                            />
                            <button
                                type="button"
                                className="chooseFileButton"
                                onClick={() => fileInputRefs.current.click()}
                            >
                                Choose image
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='btn_wrapper_save'>
                        <Button className='cancel_form_data' variant="secondary" onClick={handleModalClose}>
                            Cancel
                        </Button>
                        {/* <Button className='save_form_data' variant="primary" onClick={() => copyImageUrlToClipboard(currentImage)}>
                            Copy Image URL
                        </Button> */}
                    </div>
                </Modal.Footer>
            </Modal>




            <Modal className='modal_preview' show={showModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='contents_text'>
                        {previewdataheader && (
                            <>
                                {previewdataheader.content &&
                                    <div className='content-item'>
                                        <div dangerouslySetInnerHTML={{ __html: convertPlaceholdersToHtml(previewdataheader.content) }} />
                                    </div>
                                }
                            </>
                        )}
                        <h4 className='temp_subj'>{formik.values.subject}</h4>

                        <div>
                            <div dangerouslySetInnerHTML={{ __html: convertPlaceholdersToHtml(formik.values.content) }} />
                        </div>

                        {previewdatafooter && (
                            <>
                                {previewdatafooter.content &&
                                    <div className='content-item'>
                                        <div dangerouslySetInnerHTML={{ __html: convertPlaceholdersToHtml(previewdatafooter.content) }} />
                                    </div>
                                }
                            </>
                        )}

                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button className='close_data_form' onClick={handleCloseModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TemplateEmailCreate;
